import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import InputWithButton from '../Common/InputWithButton/InputWithButton';
import Button from '../Common/Button';

const ForgotUsernameForm = ({emailAddress, onSubmit, onChange, isSubmitted, isFormValid}) => {
        return (
            <div>
            <h2>Forgot Username</h2>
            {
                isSubmitted ?
                
                <div className="forgot-username-form">
                    <p>If the email address you entered is found, an email will be sent to you with your username. If you need additional assistance, contact your administrator or email<a href="mailto:support@getpacer.com">support@getpacer.com</a>.</p>
                    
                    <NavLink className="nav-link" to="/Login">
                        <Button 
                            type="submit"
                            bootstrapClass="outline-light mb-3"
                            text="Go to Sign In"
                        />
                    </NavLink>
                </div>
        
                :

                <form onSubmit={onSubmit} noValidate className={ isFormValid ? "forgot-username-form" : "forgot-username-form was-validated"}>
                    <p>Enter your email address below to have your username emailed to you.</p>
                    <div>
                        <InputWithButton
                            name="Email Address"
                            type="email"
                            placeholder="Email Address"
                            value={emailAddress}
                            onChange={onChange}
                            errorMessage="Please enter a valid email address"
                            isRequired={true}
                            isFocused={true}
                            showButton={true}
                            onButtonClick={onSubmit} />
                    </div>

                </form>
            }
            </div>
        )
}

ForgotUsernameForm.propTypes = {
    emailAddress: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    isSubmitted: PropTypes.bool.isRequired,
    isFormValid: PropTypes.bool.isRequired
};

export default ForgotUsernameForm;
